import "./target.scss";
import FacebookTwoToneIcon from "@mui/icons-material/FacebookTwoTone";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import PhoneIcon from "@mui/icons-material/Phone";
import PlaceIcon from "@mui/icons-material/Place";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LanguageIcon from "@mui/icons-material/Language";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Posts from "../../components/posts/Posts";
import SchedForm from "../../components/schedules/schedForm";
import { useState, useContext } from "react";
import Events from "../../components/events/Events";
import { Link } from "react-router-dom";
import api from "../../services/api";
import { useMutation, useQueryClient, useQuery } from "react-query";
import { AuthContext } from "../../context/authContext";
import { useNavigate } from "react-router-dom";// Import Material-UI components

const Target = () => {
  const targetId = parseInt(window.location.pathname.split("/")[2]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [schedMenuOpen, setSchedMenuOpen] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  
  const handleOsintClick = (event) => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleOsintClose = () => {
    setDropdownOpen(false);
  };

  const handleOsintOptionClick = (option) => {
    console.log(option);
    handleTargetRequest(option);
    handleOsintClose();
  };
  const [refresh, setRefresh] = useState(false);
  const [cases, setCases] = useState([]);

  const { data: casesData } = useQuery(
    ["cases", targetId],
    async () => {
      try {
        const res = await api.get(`/api/osint/target/${targetId}/cases/`);
        return res.data;
      } catch (error) {
        if (error.response && error.response.status === 404) {
          return [];
        }
        throw error;
      }
    }
  );
  const { isLoading: rIsLoading, data: relationshipData } = useQuery(
    ["relationship", targetId],
    async () => {
      try {
        const res = await api.get(`/api/osint/follow/${targetId}/`);
        const results = res.data.results;

        if (results.length === 0) {
          return [];
        }
        return results.map((result) => result.agent);
      } catch (error) {
        if (error.response && error.response.status === 404) {
          return [];
        }
        throw error;
      }
    }
  );

  const { isLoading, error, data: target } = useQuery(
    ["target", targetId],
    () => api.get(`/api/osint/target/${targetId}/`).then((res) => res.data)
  );

  const mutation = useMutation(
    (following) => {
      if (following) return api.delete(`/api/osint/follow/${targetId}/`);
      return api.post("/api/osint/follow/", { target: targetId });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["relationship"]);
      },
    }
  );

  const handleFollow = () => {
    mutation.mutate(relationshipData.includes(currentUser.id));
  };


  const handleTargetRequest = (action) => {
    // We will send a post request to the backend to create a new geo request
    // using the /api/osint/event/ endpoint
    // The request will contain the caseId and the type of request
    // The type of request will be 'QUERY' for now
    // The backend will then create a new event and return the event id
    // We will then reload the events component with the new event
    let data = {};
    if (action === "GEOLOCATION") {
      data = {
      event_type: 'QUERY',
      title: 'Geo Request',
      details: `Geo Information for target: ${target.name}`,
      targets: [targetId],
      metadata: {query_type: 'GEOLOCATION', targets: [{target_id: targetId, target_name: target.name, phone_numbers: target.phones.map((phone) => phone.number)}]},
      };
    } else if (action.startsWith("OSINT")) {
        // Example actions: "OSINT_30", "OSINT_90", "OSINT_30_EXPRESS"
        const actionParts = action.split("_");
        
        // Remove the first part ("OSINT") and join the rest to handle cases like "OSINT_30_EXPRESS"
        const option = actionParts.slice(1).join("_");
        if (!option) {
          console.error('OSINT action must include an option (e.g., OSINT_30).');
          return;
        }
        data = {
        event_type: 'QUERY',
        title: 'OSINT Request',
        details: `OSINT Information for target: ${target.name}`,
        targets: [targetId],
        metadata: {
          option: option,
          query_type: 'OSINT', 
          targets: [{target_id: targetId, target_name: target.name, phone_numbers: target.phones.map((phone) => phone.number)}],
        }};
    } else {
      console.error('Invalid action');
      return;
    }
    api.post('/api/osint/events/create/', data)
      .then((res) => {
        console.log(res);
        // We will trigger a reload of the events component
        setRefresh(!refresh);
      })
      .catch((err) => {
        // TODO: show the errors as dismiss messages
        console.error(err);
      });
  };


  const handleEdit = () => {
    navigate(`/edit-target/${targetId}`);
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error.message || "An error occurred"}</div>;
  }

  // Helper function to render items with a maximum of three per row
  const renderItemsWithWrapping = (items, icon) => (
    <div className="itemsContainer">
      {items.slice(0, 3).map((item, index) => (
        <div className="item" key={index}>
          {icon}
          <span>{item}</span>
        </div>
      ))}
      {items.length > 3 && (
        <div className="item" key="extra">
          {icon}
          <span>{items[3]}</span>
        </div>
      )}
    </div>
  );

  const onSchedSubmit = () => {
    setSchedMenuOpen(false);
    setRefresh(!refresh);
  }


  return (
    <div className="target">
      <div className="images">
        <img src="/images/cover_target.png" alt="Cover" className="cover" />
        <img src={target.img} alt="Target" className="targetPic" />
      </div>
      <div className="targetContainer">
        <div className="uInfo">
          <div className="center">
          <span className="targetName">{target.name}</span>
          {target.aliases && (<span className="targetAliases">{target.aliases}</span>)}
            <div className="infoSections">
              {/* Cases */}
              {casesData?.length > 0 && (
                <div className="infoSection">
                  <h3>Cases</h3>
                  <div className="itemsContainer">
                    {casesData.map((caseItem, index) => (
                      <div className="item" key={index}>
                        <span><Link to={`/case/${caseItem.id}`}>{caseItem.name}</Link></span>
                      </div>
                    ))}
                  </div>
                </div>
              )}    
              {/* Phone Numbers */}
              {target.phones?.length > 0 && (
                <div className="infoSection">
                  <h3>Phone Numbers</h3>
                  {renderItemsWithWrapping(
                    target.phones.map((phone) => phone.number),
                    <PhoneIcon />
                  )}
                </div>
              )}

              {/* Email Accounts */}
              {target.email_addresses?.length > 0 && (
                <div className="infoSection">
                  <h3>Email Accounts</h3>
                  {renderItemsWithWrapping(
                    target.email_addresses.map((email) => email.email_address),
                    <EmailOutlinedIcon />
                  )}
                </div>
              )}

              {/* Social Networks */}
              {target.social_accounts?.length > 0 && (
                <div className="infoSection">
                  <h3>Social Networks</h3>
                  <div className="itemsContainer">
                    {target.social_accounts.slice(0, 3).map((account, index) => (
                      <div className="item" key={index}>
                        {account.platform === "Facebook" && <FacebookTwoToneIcon />}
                        {account.platform === "Twitter" && <TwitterIcon />}
                        {account.platform === "Instagram" && <InstagramIcon />}
                        {account.platform === "LinkedIn" && <LinkedInIcon />}
                        {!["Facebook", "Twitter", "Instagram", "LinkedIn"].includes(
                          account.platform
                        ) && <LanguageIcon />}
                        <span>
                          <a
                            href={account.link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {account.platform}
                          </a>
                        </span>
                      </div>
                    ))}
                    {target.social_accounts.length > 3 && (
                      <div className="item">
                        <LanguageIcon />
                        <span>
                          <a
                            href={target.social_accounts[3].link}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {target.social_accounts[3].platform}
                          </a>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Addresses */}
              {target.addresses?.length > 0 && (
                <div className="infoSection">
                  <h3>Addresses</h3>
                  {renderItemsWithWrapping(
                    target.addresses.map(
                      (address) =>
                        `${address.street}, ${address.city}, ${address.state}, ${address.country}, ${address.zip_code}`
                    ),
                    <PlaceIcon />
                  )}
                </div>
              )}

              {/* Nationalities */}
              {target.nationalities?.length > 0 && (
                <div className="infoSection">
                  <h3>Nationalities</h3>
                  {renderItemsWithWrapping(
                    target.nationalities.map(
                      (nationality) =>
                    `${nationality.country_code}`),
                    <LanguageIcon />
                  )}
                </div>
              )}
            </div>

            <div className="targetButtons">
                <button className="targetButton" onClick={()=>setSchedMenuOpen(!schedMenuOpen)}>Schedule</button>
                <button className="targetButton" onClick={()=>handleTargetRequest("GEOLOCATION")}>Geo</button>
                 {/* Osint Dropdown Menu */}
              <div className="osintDropDownMenu">
                <button className="caseButton" onClick={handleOsintClick} onClose={handleOsintClose}>Osint</button>
                {dropdownOpen && <div className="dropdownMenu">
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_30")}>
                    30 days
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_60")}>
                    60 days
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_90")}>
                    90 days
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_30_EXPRESS")}>
                    30 days Express
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_60_EXPRESS")}>
                    60 days Express
                  </p>
                  <p className="menuOption" onClick={() => handleOsintOptionClick("OSINT_90_EXPRESS")}>
                    90 days Express
                  </p>
                  {/* Add more MenuItem components as needed */}
                </div>}
              </div>
              {rIsLoading ? (
                "Loading..."
              ) : (
                <button onClick={handleFollow}>
                  {relationshipData.includes(currentUser.id)
                    ? "Following"
                    : "Follow"}
                </button>
              )}
            </div>
          </div>
          <div className="right">
            <MoreVertIcon onClick={() => setMenuOpen(!menuOpen)} />
            {menuOpen && <button onClick={handleEdit}>Edit</button>}
          </div>
        </div>
        {schedMenuOpen && <SchedForm targetId={targetId} onSubmit={onSchedSubmit}/>}
        <Events targetId={targetId}  refresh={refresh}/>
      </div>
    </div>
  );
};

export default Target;